import React from 'react'
import styled from 'styled-components'

const Label = ({ text, size }) => <StyledLabel size={size}>{text}</StyledLabel>

const StyledLabel = styled.div`
  color: ${(props) => props.theme.color.grey[400]};
  font-size: ${(props) => (props.size ? props.size : 18)}px;
`

export default Label
